<p
  *ngIf="(items | async).length === 0; else itemsDisplay"
  data-cy="no-items-message"
  class="text-center"
>
  <em>No items added yet</em>
</p>
<ng-template #itemsDisplay>
  <table mat-table [dataSource]="items" class="table" data-cy="items-table">
    <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->
    <ng-container matColumnDef="eposCompact">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let element" class="cursor-pointer">
        <ng-container *ngIf="element.retail_product_id; else freeText">
          {{ element.quantity }} x{{ element.line_item_description }}
          <p class="text-gray-500 text-sm">
            {{ element.retail_product.formatted_identifiers }}
          </p>
        </ng-container>
        <ng-template #freeText>
          <p>{{ element.quantity }} x {{ element.line_item_description }}</p>
        </ng-template>
        <p *ngIf="element.serial_number">
          <small>Serial No: {{ element.serial_number }}</small>
        </p>
      </td>
    </ng-container>

    <!-- Position Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef class="w-full">Name</th>
      <td mat-cell *matCellDef="let element" class="w-full">
        <ng-container *ngIf="element.retail_product_id; else freeText">
          <a [routerLink]="['/product/retail', element.retail_product_id]">{{
            element.line_item_description
          }}</a>
          <p class="text-gray-500 text-sm">
            {{ element.retail_product.formatted_identifiers }}
          </p>
        </ng-container>
        <ng-template #freeText>
          <p>{{ element.line_item_description }}</p>
        </ng-template>
        <p *ngIf="element.serial_number">
          <small>Serial No: {{ element.serial_number }}</small>
        </p>
      </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="quantity">
      <th mat-header-cell *matHeaderCellDef>Qty</th>
      <td mat-cell *matCellDef="let element">{{ element.quantity }}</td>
    </ng-container>

    <!-- Weight Column -->
    <ng-container matColumnDef="unit_price">
      <th mat-header-cell *matHeaderCellDef>Unit price</th>
      <td mat-cell *matCellDef="let element">
        {{ element.unit_price | hlCurrency: currency : currencyRate | async }}
      </td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="tax_rate">
      <th mat-header-cell *matHeaderCellDef>Tax</th>
      <td mat-cell *matCellDef="let element">
        {{ element.tax_rate | percent: '1.0-3' }}
      </td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="price">
      <th mat-header-cell class="text-right w-auto" *matHeaderCellDef>Price</th>
      <td mat-cell class="text-right w-auto" *matCellDef="let element">
        {{
          element.quantity * element.unit_price * (element.tax_rate + 1)
            | hlCurrency: currency : currencyRate
            | async
        }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell class="text-right w-32" *matHeaderCellDef></th>
      <td mat-cell class="text-right w-32" *matCellDef="let element">
        <span class="show-on-hover">
          <a (click)="itemEditRequested.emit(element)" data-cy="edit">Edit</a>
          |
        </span>
        <span class="show-on-hover">
          <a (click)="itemDeleteRequested.emit(element.id)" data-cy="delete"
            >Delete</a
          >
        </span>
      </td>
    </ng-container>

    @if (_eposMode === false) {
      <thead>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      </thead>
    }
    <tbody>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        (click)="onRowClicked(row, $event)"
      ></tr>
    </tbody>
  </table>
</ng-template>

<!-- an hidden div is created to set the position of appearance of the menu-->
<div
  style="visibility: hidden; position: fixed"
  [style.left]="menuTopLeftPosition.x"
  [style.top]="menuTopLeftPosition.y"
  [matMenuTriggerFor]="rightMenu"
></div>

<!-- standard material menu -->
<mat-menu #rightMenu="matMenu">
  <ng-template matMenuContent let-item="item">
    @if (item.retail_product_id) {
      <button
        mat-menu-item
        [routerLink]="['/product/retail', item.retail_product_id]"
      >
        View Product
      </button>
    }
    <button mat-menu-item (click)="itemEditRequested.emit(item)">Edit</button>
    <button mat-menu-item (click)="itemDeleteRequested.emit(item.id)">
      Delete
    </button>
  </ng-template>
</mat-menu>
